import { render, staticRenderFns } from "./Store_Product_Quota.vue?vue&type=template&id=2328f21c&"
import script from "./Store_Product_Quota.vue?vue&type=script&lang=js&"
export * from "./Store_Product_Quota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Store_Product_Quota.vue"
export default component.exports